<template>
  <div>
    <!-- heading row -->
    <v-row class="mx-2 mt-1">
      <v-col cols="12" md="6">
        <h2 class="text-left">Finance Settings</h2>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row no-gutters>
      <v-col 
        cols="12"
        md="4"
        sm="4"
        v-for="(item, i) in cardItems" 
        :key="i"
      >
        <v-card 
          class="py-8 mx-4 my-4 px-8"
          :to="{ name: item.url }"
        >
          <h2 class="text--secondary text-left font-weight-medium">
            {{ item.title }}
          </h2>
        </v-card>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      multi-line
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import endpoints from "@api/repository";
// import api from "@api/index";

export default {
  name: 'FinanceSettings',

  components: {},

  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },

      cardItems: [
        {
          title: 'Finance Categories',
          url: 'FinanceCategories'
        },
        {
          title: 'Income Receipt Settings',
          url: 'AllIncomeReceiptSettings'
        },
        {
          title: 'Finance Preferences',
          url: 'FinancePreferences'
        },
      ]
    }
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },
  },

  created() {
    
  }

}
</script>

<style>

</style>